import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NavigationItem} from "../../../../../core/shared/dto/navigation/navigation-item";
import {WidgetData} from "../../../../../core/shared/widget/widget-data";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../core/shared/service/message/mvs-message.service";
import {MvsObjectNavigationService} from "../../../../../core/shared/navigation/mvs-object-navigation.service";
import {MvsObjectNavigationEntry} from "../../../../../core/shared/navigation/mvs-object-navigation-entry";
import {MvsObjectNavigationActionEnum} from "../../../../../core/shared/navigation/mvs-object-navigation-action-enum";
import {ObjectIdentifierData} from "../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../core/shared/basic/object-identifier";
import {ConfigPageComponent} from "../../../../../core/shared/mvs-page/config-page.component";
import {WidgetConfigInterface} from "../../../../../core/shared/mvs-page/interface/widget-config-page.interface";
import {PageHeaderConfig} from "../../../../../core/shared/service/page/page-header-config.interface";
import {
    MvsConfigHeaderComponent
} from "../../../../../core/shared/components/mvs-config-header/mvs-config-header.component";

@Component({
    selector: 'mvs-cf-config',
    templateUrl: 'cf-config.page.html',
    styleUrls: ['./cf-config.page.scss'],
    standalone: false
})
export class CfConfigPage extends ConfigPageComponent {


    defaultLabel: string = "Berechnungsrahmen Konfiguration";
    widgets: { [key: string]: WidgetConfigInterface} =
        {
            frequencyWidget:{
                alias: 'cf.config.frequency.widget.data.new',
                label: 'Frequenzen',
                entity: 'cf.CfFrequency',
                widgetData: new WidgetData()
            },
            paymentMomentWidget:{
                alias: 'cf.config.paymentMoment.widget.data.new',
                label: 'Zahlungszeitpunkte',
                entity: 'cf.CfPaymentMoment',
                widgetData: new WidgetData()
            },
            paymentTypeWidget:{
                alias: 'cf.config.paymentType.widget.data.new',
                label: 'Zahlungsarten',
                entity: 'cf.CfPaymentType',
                widgetData: new WidgetData()
            },
            roundingRuleWidget:{
                alias: 'cf.config.roundingRule.widget.data.new',
                label: 'Rundungsregeln',
                entity: 'cf.CfRoundingRule',
                widgetData: new WidgetData()
            }

        }

    navigationItems: NavigationItem[] = [
        {
            label: 'Frequenzen',
            action: 'frequencies',
            tooltip: 'Frequenzen',
            icon: 'fa-solid fa-wave-square',
            toggleable: false,
            default: true
        },
        {
            label: 'Zahlungszeitpunkte',
            action: 'paymentMoments',
            tooltip: 'Zahlungszeitpunkte',
            icon: 'fa-solid fa-stopwatch',
            toggleable: false,
            default: false
        },
        {
            label: 'Zahlungsarten',
            action: 'paymentTypes',
            tooltip: 'Zahlungsarten',
            icon: 'fa-solid fa-money-bill-wave',
            toggleable: false,
            default: false
        },
        {
            label: 'Rundungsregeln',
            action: 'roundingRules',
            tooltip: 'Rundungsregeln',
            icon: 'fa-solid fa-percent',
            toggleable: false,
            default: false
        }
    ];


    constructor(
        protected route: ActivatedRoute,
        protected router: Router,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected navigationService: MvsObjectNavigationService) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initialized = true;
    }

    /**
     * Called by ConfigPageComponent every time the active navigation item changes.
     */
    override postNavigationSelection() {
        // No lazy initialization needed — all widgets are declared in the widgets map
        // and initialized by ConfigPageComponent.initializeWidgets().
    }


    /**
     * Navigate to CfFrequency Object Page on row select.
     */
    onFrequencySelect(event: ObjectIdentifierData | ObjectIdentifier) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'cf.CfFrequency', event.objectId, 'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    /**
     * Navigate to CfRoundingRule Object Page on row select.
     */
    onRoundingRuleSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            'cf.CfRoundingRule', event.objectId, 'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    /**
     * Open simple entity in sidebar on row select.
     */
    handleObjectSelect(event: ObjectIdentifier | ObjectIdentifierData) {
        const entry = MvsObjectNavigationEntry.createNavigationEntry(
            event.objectType, event.objectId, 'object', '', '', '',
            MvsObjectNavigationActionEnum.edit
        );
        this.navigationService.navigateTo(entry, 'main');
    }

    getPageHeaderConfig(): PageHeaderConfig {
        return {
            component: MvsConfigHeaderComponent,
            inputs: {
                header: 'Berechnungsrahmen Konfiguration',
                icon: 'fa-light fa-calculator',
            },
        };
    }

    isNavComponent(): NavigationItem[] {
        return this.navigationItems;
    }

}


